import ModelStatus from '../../../src/data/ModelStatus.js';
var id = 0;

class WidgetDataController {

	constructor($scope, $element, $filter, $translate, serviceLogdb, serviceTranslate, serviceQueryAutoCompleteSupporter, $timeout) {

		this.serviceTranslate = serviceTranslate;
		this.serviceLogdb = serviceLogdb;
		this.scope = $scope;
        this.el = $element;
        this.$filter = $filter;
        this.$translate = $translate;
		this.instance = null;
		this.objectId = 'WidgetDataDirective' + (id++);
		this.timeout = $timeout;

		this.scope.$on('SelectDataSourceController:openDataSourceModal', (event, params) => {
			this.scope.$broadcast('WidgetDataController:openDataSourceModal', params, this.selectedDataSource);
		});

		this.scope.$on('WidgetDataController:onDataSourceChange', (event)=>{
			this.scope.onQueryChanged({'$flag':true});
		})

		this.scope.$on('AddNewWidgetController:onClose', (event, params) =>{
			this.cancelFetch();
		});
		
		this.scope.$on('WidgetPropertyEditController:onClose', (event, params) =>{
			this.cancelFetch();
		});

		this.scope.$on('ctxInit', (e) => {
			this.queryCodeMirror.setValue(this.scope.model.data.query || "");
		});

		this.scope.$on('queryRefresh', (e) => {
			this.timeout(()=>{
				this.queryCodeMirror.refresh();
				// this.queryCodeMirror.focus();
				// this.queryCodeMirror.setCursor(this.queryCodeMirror.lineCount(), 0);
			});
		});

		this.scope.$on('queryStringInit', ()=>{
			this.queryCodeMirror.setValue("");
			this.timeout(()=>{
				this.queryCodeMirror.refresh();
			});
		})

		var textarea = this.el.find('textarea');
		this.queryCodeMirror = null;
		this.serviceQueryAutoCompleteSupporter = serviceQueryAutoCompleteSupporter;
		this.serviceQueryAutoCompleteSupporter.init().then(()=> {
			this.queryCodeMirror = CodeMirror.fromTextArea(textarea[0],{
				lineNumbers: false,
				extraKeys: {
					"Ctrl-Space":"autocomplete"
				},
				lineWrapping: true,
				mode:{
					name:"edmquery", 
					"keywords": this.serviceQueryAutoCompleteSupporter.getCommandObject(),
					"autoCompleteSupporter": this.serviceQueryAutoCompleteSupporter
				},
				hintOptions:{
					closeOnUnfocus: true
				},
				theme: 'neat'

			});

			this.queryCodeMirror.display.input.textarea.addEventListener('keydown', this.handleKeyDown.bind(this));	
		});
	}

	handleKeyDown(e) {
		if ((e.ctrlKey || e.shiftKey) && e.keyCode === 13) {
			e.preventDefault();
			if(!!this.scope.isStream){
				this.isValidStreamQuery();
			}else{
				this.fetchData();
			}
		}
		else if((e.ctrlKey || e.metaKey) && e.shiftKey && e.keyCode === 68) {
			e.preventDefault();
			this.debug = !this.debug;
		} else {
			this.scope.onQueryChanged({'$flag':true});
		}
	}

	getExecutableQueryString(str) {
		if(!angular.isString(str)){
			str = '';
		}
		str = str.replace(/\n/gi, ' ').replace(/(\|)*(\s)*\$filter\$/gi, '| $filter$').replace(/(\|)*(\s)*\$drilldown\$/gi, '| $drilldown$');
	    return str.replace(/\|\s\$(drilldown|filter)\$/ig, '')
	}

	fetchData() {
		this.isSourceLoading = true;
		this.scope.model.data.query = this.queryCodeMirror.getValue();
		let queryString = this.scope.model.data.query;

		if(!!this.selectedDataSource) {
			if(!!this.scope.model.data.query) {
				// datasource
				let filterQuery = this.scope.model.data.query.replace(/^\s*\|/, '');
				queryString = `${this.selectedDataSource.query} | ${filterQuery}`;
			}
			else {
				// instant query
				queryString = `${this.selectedDataSource.query}`;
			}

		}
		let executable = this.getExecutableQueryString(queryString);

		this._oneShotQuery(executable);
	}

	cancelFetch() {
		if(!!this.instance){
			this.serviceLogdb.remove(this.instance);
			this.instance = null;
			this.isSourceLoading = false;
		}
	}

	queryChanged(){
		this.scope.onQueryChanged({'$flag':true})
	}

	_oneShotQuery(queryString, sourcePointer) {
		var DISPLAY_MAX = 1000;
		this.instance = this.serviceLogdb.create(LOGPRESSO.process.getPid());
		console.warn('_oneShotQuery::', queryString);
		this.instance.query(queryString)
		.onTail(helper => {
			this.instance.getResult(0, DISPLAY_MAX, m => {

				this.dataModel = m.body.result;
				this.fieldOrder = m.body.field_order;
				// added in issue2513
				this.fieldTypes = m.body.field_types;
				//
				this.serviceLogdb.remove(this.instance);
				this.handleChange();

				this.isSourceLoading = false;

				if(!!sourcePointer) {
					this.scope.store.unregisterWidget('EDIT', sourcePointer);
				}
				this.scope.onQueryChanged({'$flag':false});
				this.scope.$apply();
			});
		})
		.onError(() => {
			// notify('danger', '쿼리를 실행할 수 없습니다.', true);
			this.serviceLogdb.remove(this.instance);
			this.isSourceLoading = false;
			this.scope.$apply();
		})
		.failed(() => {
			notify('danger', this.$filter('translate')('$S_msg_TheQueryCouldNotBeExecuted'), true);
			this.serviceLogdb.remove(this.instance);
			this.isSourceLoading = false;
			this.scope.$apply();
		});
	}

	handleChange() {
		this.scope.onChange({
			'$data': this.dataModel,
			'$fieldOrder': this.fieldOrder,
			'$fieldTypes': this.fieldTypes
		});
	}

	handleIntervalChange() {
		this.scope.onIntervalChange({
			'$interval': this.scope.model.interval
		});
	}

	isValidInterval() {
		if(!!this.scope.model) {
			return Number.isInteger(this.scope.model.interval) && (this.scope.model.interval >= 5) && (this.scope.model.interval <= 2147483);
		}
	}

	onSelectSource(item) {
		// if(!!this.selectedDataSource && (item === null)){
		// }
		this.scope.onQueryChanged({'$flag':true})

		if(!item) {
			this.selectedDataSource = null;
			this.scope.model.data.source.guid = null;
			return;
		}
	}

	commitSource(item) {
		if(item !== this.selectedDataSource){
			this.scope.onQueryChanged({'$flag':true})
		}

		this.selectedDataSource = item;

		if(!!item) {
			this.scope.model.data.source.guid = item.guid;
		} else {
			this.scope.model.data.source.guid = null;
		}
	}

	openSelectDataSourceModal() {
		this.willBeSelectedSource = this.selectedDataSource;
		this.el.find('.mdlSelectDataSource')[0].showDialog();
		this.el.find('select-datasource')[0].setSelectedSource(this.willBeSelectedSource);
	}

	isValidStreamQuery(){
		this.scope.model.data.query = this.queryCodeMirror.getValue();
		if(!this.scope.model.data.query || this.scope.model.data.query ===''){
			notify('danger', this.$filter('translate')('$S_msg_TheQueryCouldNotBeExecuted'), true);
			return;
		}
		var queryString = this.scope.model.data.query;
		this.isSourceLoading = true;
		var result = true;
		this.serviceLogdb.verifyQuery(queryString, false, false).then(function(m){
			if(!m.body.is_valid){
				if(!!m.body.error) {
					if(typeof m.body.error.error_msg === 'string') {
						var rxNote = /note=(.*)/;
						var errorMsg = m.body.error.error_msg.match(rxNote)[0].split('note=')[1];
						if(errorMsg == 'null' || errorMsg == '') {
							errorMsg = this.serviceTranslate('$S_str_Code') + ': ' + m.body.error.error_code;
						}
						notify('danger', errorMsg, true);
					}
				} else {
					notify('danger', this.$filter('translate')('$S_msg_TheQueryCouldNotBeExecuted'), true);
				}

				result = false;
			}else{
				this.scope.onQueryChanged({'$flag':false})
				notify('success', this.$filter('translate')('$S_msg_ExecutableQuery'), true);
			}
			this.isSourceLoading = false;
			this.scope.queryValidation({'query':queryString,'isValid':result});
		}.bind(this));
	}

}

export default WidgetDataController;



// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/WidgetDataController.js